import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a977de0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-xl" }, "Giá thành sửa chữa các cấp", -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_4 = { class: "col-6 text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fw-bolder text-uppercase mb-0" }, "Giá thành sửa chữa các cấp", -1))
const _hoisted_6 = {
  class: "fst-italic mb-0",
  style: {"font-size":"0.8rem"}
}
const _hoisted_7 = {
  key: 0,
  class: "mb-0",
  style: {"font-size":"0.85rem"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end mx-5 mt-4",
  style: {"font-size":"0.8rem"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "fst-italic" }, "Ngày .... Tháng .... Năm ....")
], -1))

import { computed, ref, PropType } from "vue";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import {
  IGiaThanhSuaChuaCacCapRowResponseBase,
  INhapXuatTonKhoDonViMeta,
} from "@/core/interfaces/ApiResponses";
import GiaThanhSuaChuaCacCapTable from "../table-components/GiaThanhSuaChuaCacCapTable.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import DivCol from "@/layout/_shared/DivCol.vue";
import PdfDocumentHeader from "@/components/shared/pdf-viewer/PdfDocumentHeader.vue";
import { useAuthPdfDonVi } from "@/core/hooks/use-auth-pdf-don-vi";

const modalId = "gia-thanh-sua-chua-cac-cap-print";

export default /*#__PURE__*/_defineComponent({
  __name: 'GiaThanhSuaChuaCacCapPrintModal',
  props: {
  tenDonVi: { type: String, default: "" },
  tenDonViCha: { type: String, default: "" },
  items: {
    type: Array as PropType<IGiaThanhSuaChuaCacCapRowResponseBase[]>,
    default: () => [],
  },
  donVi: {
    type: Array as PropType<INhapXuatTonKhoDonViMeta[]>,
    default: () => [],
  },
  fromMonth: { type: Number, default: null },
  toMonth: { type: Number, default: null },
  year: { type: [String, Number], default: "" },
  capSuaChua: { type: String, default: "" },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const authDonVi = useAuthPdfDonVi();
const resolvedTenDonVi = computed(
  () => props.tenDonVi || authDonVi.tenDonVi.value
);
const resolvedTenDonViCha = computed(
  () => props.tenDonViCha || authDonVi.tenDonViCha.value
);


const emit = __emit;
const isOpen = ref(false);
const { ButtonsType } = useButtonCustom();

const onPrint = () => {
  const el = document.getElementById(modalId);
  if (!el) return;
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(
    `<html><head><style>body{font-family:Arial,sans-serif;font-size:0.8rem}table{width:100%;border-collapse:collapse}th,td{border:1px solid #ccc;padding:2px 4px}</style></head><body>${el.innerHTML}</body></html>`
  );
  w.document.close();
  w.print();
};

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    width: "95%",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(DivRow, { class: "mb-2" }, {
          default: _withCtx(() => [
            _createVNode(DivCol, { cols: 10 }),
            _createVNode(DivCol, {
              cols: 2,
              class: "text-end justify-content-end"
            }, {
              default: _withCtx(() => [
                _createVNode(ButtonCustom, {
                  "button-type": _unref(ButtonsType).PRINT,
                  onClick: onPrint
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode("In phiếu")
                  ]),
                  _: 1
                }, 8, ["button-type"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          id: modalId,
          class: "printing-paper"
        }, [
          _createVNode(PdfDocumentHeader, {
            "ten-don-vi": resolvedTenDonVi.value,
            "ten-don-vi-cha": resolvedTenDonViCha.value
          }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, " Từ tháng " + _toDisplayString(__props.fromMonth) + " đến tháng " + _toDisplayString(__props.toMonth) + " năm " + _toDisplayString(__props.year), 1),
              (__props.capSuaChua)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Cấp sửa chữa: " + _toDisplayString(__props.capSuaChua), 1))
                : _createCommentVNode("", true)
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(GiaThanhSuaChuaCacCapTable, {
                "is-print-modal": true,
                items: __props.items,
                "don-vi": __props.donVi,
                stripe: false
              }, null, 8, ["items", "don-vi"])
            ])
          ]),
          _hoisted_11
        ])
      ])), [
        [_directive_dialog_auto_focus, isOpen.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})